import { render, staticRenderFns } from "./AppEdit.vue?vue&type=template&id=b1803264&scoped=true"
import script from "./AppEdit.vue?vue&type=script&lang=js"
export * from "./AppEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1803264",
  null
  
)

export default component.exports